let authRedirectScheduled = false;

function decodeJwtPayload(token) {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) base64 += "=";
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

function isTokenExpired(token) {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== "number") return false;
  return Date.now() >= payload.exp * 1000;
}

export const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  if (isTokenExpired(token)) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return false;
  }
  return true;
};

export function clearAuthAndRedirect() {
  if (authRedirectScheduled) return;
  authRedirectScheduled = true;
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.location.assign("/admin");
}

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.location.assign("/admin");
};
